import createIcon from '../../createIcon';

/**
 * @component @name SignalCellular4Bar
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMiAyMkgyMlYyTDIgMjJaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SignalCellular4Bar = createIcon('SignalCellular4Bar', [
  ['path', { d: 'M2 22H22V2L2 22Z', key: '190juh' }],
]);

export default SignalCellular4Bar;
